// Configures i18next (side effect) before the tree renders.
import "@/shared/lib/i18n/config";

import { ReactNode } from "react";
import { RegisterModalProvider } from "./RegisterModalContext";
import { ContactModalProvider } from "./ContactModalContext";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <RegisterModalProvider>
      <ContactModalProvider>{children}</ContactModalProvider>
    </RegisterModalProvider>
  );
}
